import React from "react";
import { Col, Row, CardBody, Label } from "reactstrap";
import { DebouncedFunc } from "lodash";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface MuseumFilterProps {
  debounceFn: DebouncedFunc<(value: any) => void>;
}

const FilesFilter: React.FC<MuseumFilterProps> = ({ debounceFn }) => {
  const { t } = useTranslation("translation", { keyPrefix: "FILE_MANAGER" });
  const { control } = useFormContext();

  return (
    <React.Fragment>
      <CardBody className="border border-dashed border-end-0 border-start-0">
        <Row className="mt-3">
          <Col sm={5}>
            <Label htmlFor="" className="form-label">
              {t("DETAILS:FILTERS:SEARCH")}
            </Label>
            <div className={"search-box me-2 mb-2 d-inline-block col-12"}>
              <Controller
                name="search"
                control={control}
                defaultValue=""
                render={({ field: { onChange, value } }) => (
                  <input
                    id="search"
                    className="form-control"
                    placeholder={`${t("DETAILS:FILTERS:SEARCH")}...`}
                    value={value}
                    onChange={(e) => {
                      onChange(e);
                      debounceFn(e.target.value);
                    }}
                  />
                )}
              />
              <i className="bx bx-search-alt search-icon"></i>
            </div>
          </Col>
          <Col sm={4} className="col-xxl-4">
            <div></div>
          </Col>
        </Row>
      </CardBody>
    </React.Fragment>
  );
};
export default FilesFilter;
